import React = require("react");

import * as styles from '../../../css/components/toolbar/SimpleToolbarItem.css';
import styleable from "react-styleable";

class SimpleToolbarItem extends React.Component<any>{
    render(){
        return <span className={this.props.css.toolbarItem} {...this.props}>{this.props.children}</span>;
    }
}
export default styleable(styles)(SimpleToolbarItem);